import React, { useCallback, useEffect, useMemo, useState } from 'react';
import styled from "styled-components";
import Tile from './Tile';
import {v4} from 'uuid';
import { useDispatch, useSelector } from 'react-redux';
import {  startGame, endGame, swapTiles } from '../ducks/swapPuzzle';

//540 720
const SwapPuzzle = ({imageUrl, imageWidth=356, imageHeight=475, startDelay=5, onPuzzleFinish=f=>f})=>{
    const numOfRows = 3;
    const numOfColumns = 3;
    const [width, height] = useGameSize({originalWidth:imageWidth, originalHeight:imageHeight});

    const [startCountDown, setStartCountDown] = useState(startDelay);
    const [tilePosition, setTilePosition] = useState(null);
    
    const tilesAlignedComplete = useTilesPositionStatus();
    useSwapDispatcher();
    const dispatch = useDispatch();
    

    const ready = useSelector(state => state.swapPuzzle.ready);
    useEffect(() => {
      return () => {
        dispatch( endGame() );
      }
    }, [dispatch]);
    

    useEffect(() => {
        if ( !ready && tilesAlignedComplete) onPuzzleFinish();
      }, [tilesAlignedComplete, ready, dispatch, onPuzzleFinish]);

    const updatePosition = useCallback(() => {
        const alreadyAssignedPositions = {};
        const randomPositions = {};

        for (let j = 0; j < numOfRows; j++) {
            for (let i = 0; i < numOfColumns; i++) {
                let foundUniquePosition = false;
                while (!foundUniquePosition) {
                    const randomX = Math.floor(Math.random() * numOfColumns);
                    const randomY = Math.floor(Math.random() * numOfRows);

                    if (!alreadyAssignedPositions[`${randomX}${randomY}`]) {
                        randomPositions[`${i}${j}`] = [randomX, randomY];
                        foundUniquePosition = true;
                        alreadyAssignedPositions[`${randomX}${randomY}`] = true;
                    }
                }
            }
        }
        setTilePosition(randomPositions);
        return randomPositions;
    }, []);

    const tiles = useMemo(()=>{
        let tiles = [];
        for(let x=0 ; x<numOfRows ; x++){
            let columns = [];
            for(let y=0 ; y<numOfColumns ; y++){
                let randomX = x;
                let randomY = y;
                if(tilePosition!==null){
                    const [tempX, tempY] = tilePosition[`${x}${y}`];
                    randomX = tempX;
                    randomY = tempY;
                }
                
                
                columns.push(
                    <Tile key={v4()} 
                        imageUrl={imageUrl}
                        x={x} y={y} randomX={randomX} randomY={randomY}
                        rows={numOfRows} columns={numOfColumns}
                        imageWidth={width} imageHeight={height}
                         />
                )
            }
            tiles.push(<div key={v4()} className="row">{columns}</div>);
        }// end for rows

        return tiles;
    }, [imageUrl, width, height, tilePosition]);

    
    useEffect(()=>{
        function countDown(){
            if(startCountDown>=0){
                setStartCountDown( startCountDown-1);
            }else if(startCountDown<0){
                updatePosition();
                dispatch(startGame());
                clearInterval(intervalId);
            }
        }
        const intervalId = setInterval(countDown, 1000);
        return ()=>{
            if(intervalId!==null) clearInterval(intervalId);
        }
    }, [startCountDown, updatePosition, dispatch]);
    
    if(width===0 || height===0)return null;
    return (
        <div className="puzzleBoard">
            <StyledBoard className="boardContainer" width={width} height={height}>
                {/* <img src={imageUrl} /> */}
                {tiles}
                {startCountDown>=0 && <span className="countdown">{startCountDown===0?'시작':startCountDown}</span>}
            </StyledBoard>
        </div>
    )
}
export default SwapPuzzle;


const useSwapDispatcher = () => {
    const selectedTiles = useSelector(state => state.swapPuzzle.selectedTiles);
    const dispatch = useDispatch();
  
    useEffect(() => {
      if (selectedTiles.length === 2) {
        dispatch(swapTiles());
      }
    }, [selectedTiles, dispatch]);
};


const useTilesPositionStatus = () => {
    const [areTilesInPosition, setAreTilesInPosition] = useState(false);
    const tilesStatus = useSelector(state => state.swapPuzzle.tilesStatus);
    const ready = useSelector(state => state.swapPuzzle.ready);
    useEffect(() => {
        if(ready)return;
        // 퀴즈가 시작될때 {} 상태일때가 있다. 이럴경우는 return 완성이 아니도록 하기위해서
        if( Object.keys(tilesStatus).length === 0 && tilesStatus.constructor === Object ) return;

      const areInPosition = Object.values(tilesStatus).every( status => status === true );
      setAreTilesInPosition(areInPosition);
    }, [tilesStatus, setAreTilesInPosition, ready]);
  
    return areTilesInPosition;
  };
  
  const useGameSize = ({originalWidth: width, originalHeight:height, minWidth=300, horizontalOverflow=false})=>{
    const [newSize, setNewSize] = useState({width, height});
    // const isHorizontal = ( width>height );

    useEffect(() => {
        function handleResize() {
            const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            const screenHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            let newWidth = Math.max( Math.min(screenWidth, width), minWidth );
            if(newWidth>=width) return;
            let scale = newWidth/width; 
            let newHeight = height * scale;
            if(!horizontalOverflow){
                const tempHeight = Math.min(screenHeight, newHeight);
                if(tempHeight<newHeight){
                    scale = tempHeight / height;
                    newHeight = tempHeight;
                    newWidth = width * scale;
                }
            }
            setNewSize({width:newWidth, height:newHeight});
        }
    
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => {
          window.removeEventListener('resize', handleResize);
        };
      }, [width, height, horizontalOverflow, minWidth]);
    
      return [newSize.width, newSize.height];
}


const StyledBoard = styled.div`
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
`;